import { Stack } from '@mantine/core';
import type { FC } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { TextInput } from '../../../components/reactHookFormMantine/TextInput.tsx';
import { useI18n } from '../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../IncompleteEventForm/schema.ts';

export const Links: FC<{
  useFormValue: UseFormReturn<IncompleteEventFormComplete>;
}> = ({ useFormValue: { control } }) => {
  const { t } = useI18n();

  return (
    <Stack gap="md" pos="relative">
      <Stack gap="xs" pos="relative">
        <TextInput
          control={control}
          label={t('event-form_field-label--ticketshop-link') ?? 'Ticketshop link'}
          name="ticketshopLink"
        />
        <TextInput
          control={control}
          label={t('event-form_field-label--website-link') ?? 'Website link'}
          name="websiteLink"
        />
        <TextInput
          control={control}
          label={t('event-form_field-label--instagram-link') ?? 'Instagram link'}
          name="instagramLink"
        />
        <TextInput
          control={control}
          label={t('event-form_field-label--tiktok-link') ?? 'TikTok link'}
          name="tiktokLink"
        />
        <TextInput control={control} label={t('event-form_field-label--spotify-link') ?? 'Music'} name="spotifyLink" />
      </Stack>
    </Stack>
  );
};
